import script from "./SideBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideBanner.vue?vue&type=script&setup=true&lang=ts"

import "./SideBanner.vue?vue&type=style&index=0&id=51145e37&lang=scss"

const __exports__ = script;

export default __exports__